import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class DeviceCheck implements CanActivate {

  constructor(
    private platform: Platform,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // const targetUrl = state.url;
    // console.log(targetUrl);
    const isDesktop = this.isDesktop();
    if (isDesktop) {
      // this.router.navigate(['/desktop']);
      // return false;
      return true;
    }
    else {
      return true;
    }
  
  }

  private isDesktop(): boolean {
    return this.platform.is('desktop');
  }
}
